import { useMemo } from "react";

import {
  Box,
  Grid,
  Text,
  // HStack,
  // VStack,
  Heading,
  // useToast,
  // CircularProgress,
  Container,
  Breadcrumb,
  BreadcrumbItem,
  List,
  ListItem,
  // useDisclosure,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Button from "components/Button/Button";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";
import toLower from "lodash/toLower";
import { format, parseISO } from "date-fns";
// import { useGetApplicableLoanRatesQuery } from "services/walletApi";

function DetailItem(props) {
  const { _title, _value, itemTitle, value } = props;

  return (
    <ListItem
      bg="#FCFCFC"
      py="10px"
      px="24px"
      borderBottom="1px solid #EAEAEA4f"
    >
      <Box>
        <Text fontSize="12px" color="#4E4B66" fontWeight="400" {..._title}>
          {itemTitle}
        </Text>
        <Text fontSize="md" fontWeight="400" color="#14142B" {..._value}>
          {value}
        </Text>
      </Box>
    </ListItem>
  );
}

export default function LoanDetails(props) {
  const currentPage = "Home";

  const history = useHistory();

  // const loan = { _id: "12345" };

  const loan = useMemo(() => props?.location?.state, [props]);

  const loanRate = useMemo(() => loan?.interest?.rate, [loan]);

  console.log("LOAN", loan);

  const canPayback = useMemo(() => loan?.loanStatus === "running", [loan]);

  const loanInfo = useMemo(() => {
    const map = {
      pending: { color: "#F4B740", label: "Pending" },
      cancelled: { color: "#ED2E7E", label: "Cancelled" },
      denied: { color: "#ED2E7E", label: "Denied" },
      processing: { color: "#F1F440", label: "Processing" },
      running: { color: "#03A438", label: "Approved" },
      paid: { color: "#03A438", label: "Paid" },
      defaulted: { color: "#ED2E7E", label: "Defaulted" },
    };

    return map[toLower(loan?.loanStatus) ?? "pending"];
  }, [loan]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bcpl">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Loan details</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/bcpl">BCPL</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Loan details
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Grid
              templateColumns={["1fr", "1fr", "repeat(2, 1fr)"]}
              mt="32px"
              gap="20px"
            >
              <Box
                bg="white"
                borderRadius="16px"
                shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
                p="48px"
              >
                <List>
                  <DetailItem
                    itemTitle="Coin Type"
                    value={toCoinLocale(loan?.coin)}
                  />
                  <DetailItem
                    itemTitle="Date"
                    value={format(
                      parseISO(loan?.timeline?.createdAt),
                      "dd. MMM. yyyy"
                    )}
                  />
                  <DetailItem
                    itemTitle="Coin Value"
                    value={toPrecision(loan?.coinValue, loan?.coin)}
                  />
                  <DetailItem
                    itemTitle="Value Received in USD"
                    value={`${loan?.currencyValue} USD`}
                  />

                  <DetailItem
                    itemTitle="Value to pay in USD"
                    value={`${Math.round(
                      +loan?.currencyValue * (1 + (loanRate ?? 10) / 100)
                    )} USD`}
                  />

                  <DetailItem
                    itemTitle={`Interest rate (${loanRate}%)`}
                    value={`${loanRate}%`}
                  />

                  <DetailItem
                    itemTitle="Status"
                    value={loanInfo?.label}
                    _value={{ color: loanInfo?.color }}
                  />

                  <DetailItem
                    itemTitle="Loan Duration"
                    value={`${loan?.timeline?.duration} ${loan?.timeline?.durationUnit}`}
                  />
                  <DetailItem
                    itemTitle="Payback date"
                    value={format(
                      parseISO(loan?.timeline?.dueAt),
                      "dd. MMM. yyyy"
                    )}
                  />
                </List>

                <Button
                  minW="100%"
                  minH="64px"
                  mt="40px !important"
                  disabled={!canPayback}
                  // isLoading={isLoading}
                  onClick={() =>
                    history.push(`/dashboard/bcpl/${loan?._id}/payback`, loan)
                  }
                >
                  Payback
                </Button>
              </Box>
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
